import React from 'react';

export interface AndTabPaneProps {
  /** Tab 显示文案，供 AndTabs / antd useLegacyItems 解析 */
  tab?: string;
  key?: string;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  forceRender?: boolean;
}

/**
 * AndTabPane — 导出页 Tab 面板标记组件。
 * 自身不渲染 UI（与 antd 6 废弃 TabPane 一致）；内容由父级 Tabs 通过 children props 解析。
 */
export const AndTabPane: React.FC<AndTabPaneProps> = () => null;

AndTabPane.displayName = 'AndTabPane';

export default AndTabPane;
